// @flow

import * as React from 'react';
import { HoverMenu } from '@ta/brand.global-nav';
import { Icon } from '@ta/styleguide.icon';
import classNames from '@ta/common.classnames';
import { featureIsEnabled } from '@ta/common.features';
import styles from './BreadcrumbsItem.less';

type Props = {|
  /**
   * crumb item display name
   */
  displayName: string,

  /**
   * crumb item url
   */
  href: string,

  /**
   * Last items are special in the way that they do not need a chevron, and are not a link
   */
  isLastItem: boolean,

  /**
   * If true, this appears over a solid background rather than an imaage, so we should simplify
   * the style
   */
  flat: boolean,
|};

const BreadcrumbsItem = ({ displayName, href, isLastItem, flat }: Props) => {
  const showGlobalNav = featureIsEnabled('breadcrumbs_as_global_nav');

  if (isLastItem) {
    if (showGlobalNav) {
      return (
        <HoverMenu
          name="breadcrumb_menu"
          onClickInsteadOfHover
          triggerNode={
            <span
              className={classNames(styles.breadcrumb, styles.lastLink, {
                [styles.flat]: flat,
              })}
            >
              <span>{displayName}</span>
              <Icon name="caret-down" />
            </span>
          }
          noMenuNode={
            <span
              className={classNames(styles.breadcrumb, styles.lastLink, styles.noMenu, {
                [styles.flat]: flat,
              })}
            >
              {displayName}
            </span>
          }
        />
      );
    }

    return (
      <span
        className={classNames(styles.breadcrumb, styles.lastLink, {
          [styles.flat]: flat,
        })}
      >
        {displayName}
      </span>
    );
  }

  return (
    <span className={classNames(styles.breadcrumb, { [styles.flat]: flat })}>
      <a className={styles.breadcrumbLink} href={href}>
        {displayName}
      </a>
      <Icon className={styles.chevron} name="single-chevron-right" />
    </span>
  );
};

export default BreadcrumbsItem;
